import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  limpadorFiltros,
  mudarFiltros,
  mudarManejador,
  revelarBarraFiltragem
} from '../../../redux/actions/index'

import Consumo from './Consumo'
import Historico from './Historico'
import * as S from './styles'

export default function DashboardPortadoras() {
  const despacho = useDispatch()

  let filtros = useSelector((state) => state.filtrosState.filtros)
  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(mudarManejador('dashboardComsumoEHistorico'))
    despacho(limpadorFiltros(true))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <S.Container>
      <Historico />
      <Consumo />
    </S.Container>
  )
}
